// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServiceForDto } from './IServiceForDto';
import {
    IServiceForDtoFromJSON,
    IServiceForDtoFromJSONTyped,
    IServiceForDtoToJSON,
    IServiceForDtoToJSONTyped,
} from './IServiceForDto';

/**
 * 
 * @export
 * @interface IRelatedClaimEnhancedDto
 */
export interface IRelatedClaimEnhancedDto {
    /**
     * 
     * @type {number}
     * @memberof IRelatedClaimEnhancedDto
     */
    claim_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IRelatedClaimEnhancedDto
     */
    service_on?: Date;
    /**
     * 
     * @type {IServiceForDto}
     * @memberof IRelatedClaimEnhancedDto
     */
    service_for?: IServiceForDto;
    /**
     * 
     * @type {string}
     * @memberof IRelatedClaimEnhancedDto
     */
    current_claim_status?: IRelatedClaimEnhancedDtoCurrentClaimStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IRelatedClaimEnhancedDto
     */
    plan_year_names?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum IRelatedClaimEnhancedDtoCurrentClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IRelatedClaimEnhancedDto interface.
 */
export function instanceOfIRelatedClaimEnhancedDto(value: object): value is IRelatedClaimEnhancedDto {
    return true;
}

export function IRelatedClaimEnhancedDtoFromJSON(json: any): IRelatedClaimEnhancedDto {
    return IRelatedClaimEnhancedDtoFromJSONTyped(json, false);
}

export function IRelatedClaimEnhancedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRelatedClaimEnhancedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'service_for': json['service_for'] == null ? undefined : IServiceForDtoFromJSON(json['service_for']),
        'current_claim_status': json['current_claim_status'] == null ? undefined : json['current_claim_status'],
        'plan_year_names': json['plan_year_names'] == null ? undefined : json['plan_year_names'],
    };
}

export function IRelatedClaimEnhancedDtoToJSON(json: any): IRelatedClaimEnhancedDto {
    return IRelatedClaimEnhancedDtoToJSONTyped(json, false);
}

export function IRelatedClaimEnhancedDtoToJSONTyped(value?: IRelatedClaimEnhancedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString().substring(0,10)),
        'service_for': IServiceForDtoToJSON(value['service_for']),
        'current_claim_status': value['current_claim_status'],
        'plan_year_names': value['plan_year_names'],
    };
}

